import { useReducer, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Container, Grid, MenuItem, Paper, TextField, Typography, useTheme } from "@mui/material";
import CustomBreadcrumbs from "../../../../components/breadcrumbs";
import SectionTitle from "../../../../components/sectionTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faNfcSymbol } from "@fortawesome/free-brands-svg-icons";
import ReactQuill from "react-quill";
import { Dropzone, FileMosaic } from "@files-ui/react";
import { create } from "../../../../controllers/company/cashless/EconomiesController";
import QUDProgress from "../../../../components/progress";
import ResponseComponent from "../../../../components/responseComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const initialState = {
    name:'',                errorName:false,
    mode:'',                errorMode:false,
    type:'',                errorType: false,
    technology:'',          errorTechnology: false,
    decription:'',          errorDescription: false,
    termsAndConditions:'',  errorTermsAndConditions: false,
    cover: [],
    img:[],

    title:'',
    message:'',
    success:false,
    open:false
    
}
  
function reducer( state, { field, value })
{
    return{
        ...state,
        [field] : value
    }
}

export default function CashlessEconomyCreate()
{
    const theme = useTheme();

    const [state,setState] = useReducer(reducer,initialState);
    const [isLoading,setIsLoading] = useState(false);
    
    const {
        name, mode, type, technology, description, termsAndConditions,
        errorName, errorMode, errorType, errorTechnology, errorDescription,
        errorTermsAndConditions,
        cover, img, title, message, success, open
    } = state;

    const history = useHistory();

    /*const [name,setName] = useState();
    const [mode,setMode] = useState();
    const [type,setType] = useState();*/

    const onChange = (e) => {
        setState({field : e.target.name, value : e.target.value});
    }

    const handleLogoImage = async (incomingFiles) =>
    {
        console.log('incomingFiles ===> ',incomingFiles[0].file);
        setState({field:'cover',value:incomingFiles});
        setState({field:'img',value:incomingFiles[0].file})
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        let response = await create(name,mode,type,technology,description,termsAndConditions);
        if(response.success === true)
        {
            setState({field:'title',value:'Operación Exitosa'});
            setState({field:'message',value:response.message});
            setState({field:'success',value:true});
            setState({field:'open',value:true});
        }
        else
        {
            setState({field:'title',value:'Operación Fallida'});
            setState({field:'message',value:response.message});
            setState({field:'success',value:false});
            setState({field:'open',value:true});
        }
        console.log(response)
        setIsLoading(false);
    }

    const handleClose = () => {
        if(success === true)
            history.push('/cashless');
        else
            setState({field:'open',value:'false'})
    }


    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs crumbs={[{name:'Cashless',link:'/cashless/economies'}]} returnTo={"/"}/>
            <SectionTitle title={"Economia"} subtitle={"(Crear)"}/>
            <br/>
            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                    <Paper elevation={1}>
                        <Grid container spacing={3}>
                            <Grid item lg={12} xl={12}>
                                <Typography variant="h6" component={'h1'} gutterBottom>
                                    <FontAwesomeIcon icon={faNfcSymbol} color={theme.palette.link.main} />
                                    &nbsp;¡Construye tu mundo cashless! Dale vida a tu economía digital y da el primer paso hacia una gestión innovadora.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                    <Accordion sx={{borderRadius:20}}>
                        <AccordionSummary
                            expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box>
                                <Typography variant="h6">Detalles</Typography>
                                <Typography color={'#637381'}>Nombre, modo, tipo, descripción, logo...</Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3}>
                                {/**Name */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <TextField
                                        fullWidth
                                        label='Nombre de la economia'
                                        name='name'
                                        id='name'
                                        required
                                        value={name}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorName',value:name === ''}) }
                                        error = {errorName}
                                        helperText={errorName && <Typography>Ingrese el nombre de la economia</Typography>}
                                    />
                                </Grid>
                                {/**Mode */}
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        select
                                        id="mode"
                                        name='mode'
                                        label="Modalidad"
                                        variant="outlined"
                                        value = {mode}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorMode',value:mode === ''}) }
                                        error = {errorMode}
                                        helperText={errorMode && <Typography>Selecciona la modalidad de la economía</Typography>}
                                    >
                                        <MenuItem value=''>Selecciona una modalidad</MenuItem>
                                        <MenuItem value='online'>Online</MenuItem>
                                        <MenuItem value='offline'>Offline</MenuItem>
                                    </TextField>
                                </Grid>
                                {/**Technology */}
                                <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <TextField
                                        fullWidth
                                        select
                                        id="technology"
                                        name='technology'
                                        label="Tecnología"
                                        variant="outlined"
                                        value = {technology}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorTechnology',value:technology === ''}) }
                                        error = {errorTechnology}
                                        helperText={errorType && <Typography>Selecciona la tecnología a utilizar</Typography>}
                                    >
                                        <MenuItem value=''>Selecciona la tecnologia</MenuItem>
                                        <MenuItem value='qr'>QR</MenuItem>
                                        <MenuItem value='nfc'>NFC</MenuItem>
                                    </TextField>
                                </Grid>
                                {/**Type */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <TextField
                                        fullWidth
                                        select
                                        id="type"
                                        name='type'
                                        label="Uso de la economía"
                                        variant="outlined"
                                        value = {type}
                                        onChange = { onChange }
                                        onBlur={ () => setState({field:'errorType',value:type === ''}) }
                                        error = {errorType}
                                        helperText={errorType && <Typography>Selecciona para que es la economía</Typography>}
                                    >
                                        <MenuItem value=''>Selecciona el uso de la economía</MenuItem>
                                        <MenuItem value='event'>Evento</MenuItem>
                                        <MenuItem value='club'>Club</MenuItem>
                                        <MenuItem value='community'>Comunidad</MenuItem>
                                        <MenuItem value='business'>Negocio</MenuItem>
                                        <MenuItem value='loyalty_program'>Programa de Lealtad</MenuItem>
                                        <MenuItem value='school'>Escuela</MenuItem>
                                        <MenuItem value='parking'>Estacionamiento</MenuItem>
                                        <MenuItem value='transport'>Transporte</MenuItem>
                                        <MenuItem value='other'>Otro</MenuItem>
                                    </TextField>
                                </Grid>

                                {/**Description */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography fontWeight={'bold'}>Descripción</Typography>
                                    <Typography fontStyle={'italic'}>Ingresa detalles adicionales de tu economía Cashless</Typography>
                                    <ReactQuill
                                        theme="snow"
                                        placeholder="Describe tu economía cashless en detalle. Incluye información sobre su propósito, cómo funciona, los beneficios para los participantes y cualquier otra característica relevante.."
                                        id="description"
                                        value={description}
                                        onChange={(value)=>setState({field:'description',value:value})}
                                        onBlur={()=>setState({field:'errorDescription',value:description===''?true:false})}
                                        style={{height:300}}
                                    />
                                    {
                                        errorDescription &&
                                        <Typography color={'error.main'}>Ingresa la descripción de la economía</Typography>
                                   }
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={5}>
                                    <Typography>Logo de la economía</Typography>
                                    <Dropzone
                                        onChange={handleLogoImage}
                                        value={cover}
                                        maxFiles={1}
                                        accept="image/*"
                                    >
                                        {cover.map((file) => (
                                            <FileMosaic key={file.id} {...file} onDelete={()=>{setState({field:'cover',value:[]}); setState({field:'img',value:[]}) }} info preview smartImgFit={"center"}/>
                                            ))}
                                        {
                                            cover.length === 0 &&
                                            <>
                                                <Typography>
                                                    Para el logo de la economía, recomendamos una proporción de 1:1, cuadrada, 512×512 píxeles.
                                                    <br/>PNG, JPG, JPEG hasta 1MB
                                                </Typography>
                                                <Typography variant="body2" color='link.main' fontWeight={'bold'}>
                                                    Arrastra y suelta tu imagen o haz clic para seleccionarla
                                                </Typography>
                                            </>
                                        }
                                    </Dropzone>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
                    <Accordion sx={{borderRadius:20}}>
                        <AccordionSummary
                            expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box>
                                <Typography variant="h6">Terminos y condiciones</Typography>
                                <Typography color={'#637381'}>Terminos y condiciones de uso</Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={3}>
                                {/**Terms and Conditions */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={5}>
                                    <Typography fontWeight={'bold'}>Terminos y condiciones</Typography>
                                    <Typography fontStyle={'italic'}>Establece los terminos y condiciones de uso de tu economia Cashless</Typography>
                                    <ReactQuill
                                        theme="snow"
                                        placeholder="Redacta los términos y condiciones que regirán esta economía cashless. Incluye información sobre el uso de las tarjetas o dispositivos, políticas de recarga y reembolso, responsabilidades, privacidad de datos y cualquier otra normativa importante que los participantes deben conocer y aceptar."
                                        id="termsAndConditions"
                                        value={termsAndConditions}
                                        onChange={(value)=>setState({field:'termsAndConditions',value:value})}
                                        onBlur={()=>setState({field:'errorTermsAndConditions',value:termsAndConditions===''})}
                                        style={{height:300}}
                                    />
                                    {
                                        errorTermsAndConditions &&
                                        <Typography color={'error.main'}>Ingresa la Terminos y condiciones de la economía</Typography>
                                    }
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={8} xl={8} display={'flex'} flexDirection={'row'} justifyContent={"flex-end"}>
                    <Button variant="contained" onClick={()=>handleSubmit()}>
                        <Typography variant="h6">
                            Crear Economia
                        </Typography>
                    </Button>
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
                //secondaryText={'No'}
                //secondaryAction={()=>history.push('/categories')}
            />
        </Container>
    )
}